var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"right-tool\"\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col-xs-12\"\u003E\u003Ch1 class=\"section-big-title\"\u003EThe Right Tool\u003Cbr class=\"rm-break\"\u003E for The Right Job\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E" + (null == (pug_interp = require("./list-module-02.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fsection\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/gdpr/view/right-tool.pug
// module id = 1272
// module chunks = 0